/* src/app/shared/components/kebab/kebab.component.scss */
.hide-kebab {
  display: none;
}
.show-kebab {
  display: block;
}
.show-kebab-above {
  bottom: 100%;
  top: auto;
}
.right-align {
  right: 0;
  left: auto;
}
.kebab-menu-height {
  max-height: 290px !important;
}
.left-align {
  margin-right: 100px;
}
::ng-deep #copyContainer span {
  display: none;
}
.modal-content {
  z-index: 1010;
  text-align: left;
}
#okCancelModal .modal-content {
  height: 206px;
}
.modal-dialog {
  position: relative;
  top: 50%;
  width: 300px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-more-info {
  position: fixed;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: calc(50% - 150px);
}
.modal-dialog-more-info-new {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-more-info-new .modal-content {
  height: auto;
}
.modal-dialog-more-info-new .modal-content .iframe-body-single {
  height: 380px;
  width: 552px;
}
.modal-dialog-more-info-new .modal-content .iframe-body-multiple {
  height: 284px;
  width: 552px;
}
.modal-dialog-copy {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
  cursor: default;
}
.title-text > p {
  color: #222222;
  font-size: 16px;
}
.modal-container-new {
  position: relative;
  width: 100%;
  background: transparent;
  height: 100%;
}
.modal-header-new {
  background-color: #174d5c;
  color: #fff;
  height: 45px;
  padding: 12px 18px 12px 20px;
}
.modal-header-new .modal-title {
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
}
.modal-header-new #deleteTitle {
  font-weight: 700;
}
.modal-header-new #editQuestionTitle,
.modal-header-new #questionUsedModalTitle {
  font-size: 16px;
  font-weight: 400;
}
.modal-header-new #moreInfoTitle {
  font-weight: 400;
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 20px;
}
.modal-body-new .container-fluid > p {
  color: #222222;
}
.modal-body-copy {
  position: relative;
  flex: 1 1 auto;
  margin-bottom: 0;
}
.label-info {
  font-size: 14px;
  font-weight: bold;
}
.label-span {
  font-size: 14px;
}
.label-question {
  font-weight: normal;
  font-size: 12px;
}
.label-span-question {
  font-weight: normal;
  font-size: 12px;
}
.modal-footer-new {
  background-color: #f0f3f4;
  border-top: 1px solid #d1dbde;
  padding: 6px 0 8px 16px;
  text-align: left;
}
.modal-footer-new button {
  width: 130px;
}
.unique-error {
  width: 100%;
  color: #b0181e;
  text-align: left;
  font-weight: 400;
}
.line-divider {
  width: 90%;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top: 3px solid #c1cfd4;
}
.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-size: 0px;
}
#previewModal #previewModalOverlay {
  background-color: rgba(0, 0, 0, 0.2);
}
#previewModal .modal-dialog {
  transform: translateX(-247%) translateY(-50%);
}
#previewModal .modal-dialog #previewIframe {
  border: none;
  width: 700px;
  min-height: 800px;
}
#previewModal .modal-dialog .preview-model-content {
  width: 800px !important;
  height: 600px !important;
}
.preview-content {
  width: 800px !important;
  height: 650px !important;
}
.preview-body {
  width: 700px !important;
  height: 345px !important;
  border-radius: 10px;
  border: none;
}
button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
}
.close {
  height: 20px;
  width: 20px;
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 1;
  filter: alpha(opacity=30);
}
.question-body {
  width: 735px !important;
  height: 438px !important;
  border: 1px solid gray;
}
.question-sequence {
  width: 733px !important;
  height: 40px;
  background-color: #c1cfd4;
  font-size: 16px;
}
.button-align {
  margin-top: 25px;
}
.last-kebab {
}
.editor-msg {
  padding: 100px 20px 100px 175px;
  font-size: 25px;
  color: #666666;
}
.modal-header-message {
  padding: 0px 0px 27px 0px;
}
.header-span {
  font-weight: bold;
  color: #000;
  margin: 0;
  font-size: 16px;
}
.whr-hav-used-tbl {
  height: 200px;
  display: inline-block;
  width: 100%;
  overflow: hidden auto;
}
.whr-hav-used-tbl-no-height {
  display: inline-block;
  width: 100%;
  overflow: hidden auto;
}
.whr-hav-used-tbl-txt {
  color: #666666;
  font-size: 14px;
  font-weight: normal;
}
.hide-list {
  display: none;
}
.show-list {
  display: block;
  left: auto;
  top: -9px;
  right: 100%;
}
.title-div {
  font-size: 18px;
  padding-left: 15px;
  top: 5px;
  position: relative;
  font-weight: bold;
}
.ahe-ui-dropdown .dropdown-menu {
  position: absolute;
  width: fit-content;
}
.ahe-ui-dropdown .show-kebab li {
  padding: 0;
  margin: 0;
  border: none !important;
  background: none;
  margin-top: 0px !important;
}
.ahe-ui-dropdown .dropdown-menu .dropdown-item {
  color: #265867;
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 400;
  outline: 0;
  padding: 10px;
  text-decoration: none;
  white-space: nowrap;
}
.ahe-ui-dropdown .dropdown-menu .dropdown-item .dropdown-item:hover {
  background-color: #f5f5f5 !important;
}
.ahe-ui-dropdown .dropdown-menu .dropdown-item .dropdown-item:focus {
  border-color: #265867 !important;
  background-color: #f5f5f5 !important;
}
.ahe-ui-dropdown .dropdown-menu li a:hover,
.dpg-ui-dropdown .dropdown-menu li a:hover {
  border-bottom-left-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  background-color: #f5f5f5 !important;
}
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-color: #f5f5f5 !important;
}
.ahe-ui-dropdown .dropdown-menu li:not([aria-disabled=true]) a.dropdown-item:focus {
  border: 2px solid #265867;
  background-color: #f5f5f5 !important;
}
.book-information-inline-list li {
  display: inline;
}
.inline-list {
  list-style: none;
  padding: 0;
}
.btn.btn-secondary.active {
  background-color: transparent !important;
  box-shadow: none !important;
}
.btn.btn-secondary.active:hover {
  background-color: #e0e7e9 !important;
}
button.close:focus,
button.close:focus-visible {
  outline: auto;
  outline-offset: 0;
  background-color: transparent;
}
button.close:focus:not(:focus-visible) {
  outline: auto;
  outline-offset: 0;
  background-color: transparent;
}
.book-information-inline-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.book-information-inline-list div {
  display: inline-block;
}
.book-information-inline-list dt {
  display: inline;
  margin-right: 5px;
}
.book-information-inline-list dd {
  display: inline;
  margin: 0;
  margin-right: 15px;
}
button.close:focus,
button.close:focus-visible,
button.close:focus:not(:focus-visible) {
  outline: auto;
  outline-offset: 0;
  background-color: transparent;
}
button.close:not([disabled]):hover {
  background-color: transparent;
}
@media (max-width: 600px) {
  .modal-overlay {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
  .modal-container-new {
    max-width: 95dvw;
    display: flex;
  }
  .modal-dialog-copy {
    width: 100%;
  }
  .modal-content {
    height: 100%;
  }
  .modal-body-copy {
    overflow-x: hidden;
    padding: 16px 12px;
    font-size: 12px;
  }
  .modal-footer-new {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 6px 0;
  }
  .modal-dialog-more-info-new {
    width: 100%;
  }
  .modal-dialog-more-info-new .modal-content {
    height: 100%;
  }
  .modal-dialog-more-info-new .modal-body-new {
    padding: 16px 12px;
    overflow-y: auto;
  }
  .modal-dialog-more-info-new .modal-footer-new:has(> *:only-child) {
    justify-content: flex-end;
  }
  .title-div {
    font-size: 14px;
    font-weight: 600;
  }
  #okCancelModal .modal-content {
    height: 100%;
  }
}
@media (max-width: 600px) and (max-width: 405px) {
  #editModal .modal-overlay {
    padding: 5px 0;
  }
  #editModal .modal-overlay .modal-footer-new {
    flex-direction: column;
    gap: 10px;
  }
}
@media (max-height: 408px) {
  #whereIHaveUsedframe .modal-overlay {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
  #whereIHaveUsedframe .modal-container-new {
    max-width: 95dvw;
    display: flex;
  }
  #whereIHaveUsedframe .modal-dialog-copy {
    width: 100%;
  }
  #whereIHaveUsedframe .modal-content {
    height: 100%;
  }
  #whereIHaveUsedframe .modal-body-copy {
    overflow-x: hidden;
    padding: 16px 12px;
    font-size: 12px;
  }
  #whereIHaveUsedframe .modal-footer-new {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 6px 0;
  }
  #whereIHaveUsedframe .modal-dialog-more-info-new {
    width: 100%;
  }
  #whereIHaveUsedframe .modal-dialog-more-info-new .modal-content {
    height: 100%;
  }
  #whereIHaveUsedframe .modal-dialog-more-info-new .modal-body-new {
    padding: 16px 12px;
    overflow-y: auto;
  }
  #whereIHaveUsedframe .modal-dialog-more-info-new .modal-footer-new:has(> *:only-child) {
    justify-content: flex-end;
  }
}
@media (max-height: 430px) and (min-width: 600px) {
  #viewMore .modal-body-new {
    max-height: calc(95dvh - 105px);
    overflow-y: auto;
  }
}
.inline-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.inline-list div {
  margin-right: 20px;
}
.inline-list dt {
  display: inline;
  margin-right: 5px;
}
.inline-list dd {
  display: inline;
  margin: 0;
  margin-right: 15px;
}
.assessment-info-item {
  margin-bottom: 5px;
}
@media (max-width: 430px), (min-width: 768px) and (max-width: 991px) {
  .ahe-ui-dropdown .dropdown-menu {
    min-width: 125px;
    width: 125px;
  }
  .ahe-ui-dropdown .dropdown-menu .dropdown-item {
    white-space: normal;
  }
  .ahe-ui-dropdown .show-list {
    left: -126px;
  }
}
.error-container {
  display: flex;
  color: #b0181e;
  margin-top: 10px;
  font-size: 16px;
}
.ahe-ui .input-container .form-control.is-invalid,
.ahe-ui .input-container .form-control:focus.is-invalid {
  border: 1px solid #b0181e;
  box-shadow: 0 2px 0 0 red;
}
.copy-error-message {
  font-weight: 400;
}
.assignment-list-container {
  padding: 0 16px;
  margin: 0;
}
.assignment-list {
  border: 1px solid #d1dbde;
  list-style: none;
  margin: 0;
  padding: 0;
}
.assignment-list-item {
  display: block;
  border-bottom: 1px solid #e9ecef;
  padding: 8px 0 8px 20px;
}
/*# sourceMappingURL=kebab.component.css.map */
